import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {getLicenseDataModules} from 'src/openapi/admin/apis/GetLicenseDataModulesApi';
import {useAppDispatch} from 'src/store/hooks';

import {selectLicenseDataModules} from './services/dictionary-slice';

export const useLicenseDataModules = () => {
    const apiDispatch = useAppDispatch();
    const licenseDataModules = useSelector(selectLicenseDataModules);

    const loadLicenseDataModules = useCallback(() => {
        if (!licenseDataModules.length) {
            apiDispatch(getLicenseDataModules());
        }
    }, [licenseDataModules.length, apiDispatch]);

    return {licenseDataModules, loadLicenseDataModules};
};
